import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
export const useMonthlyDisabledFeatures = productId => {
  const p3Context = PremiumPurchasePlatformModule.internals.useContext();
  const {
    data: featuresGridData = {},
    ...asyncState
  } = PremiumPurchasePlatformModule.SDK.ApiClient.hooks.useGetFeaturesGrid({
    productIds: [String(productId)],
    ...p3Context
  }, Boolean(productId));
  const disabledInMonthly = React.useCallback(feature => {
    var _feature$metadata;
    return Boolean(((_feature$metadata = feature.metadata) == null ? void 0 : _feature$metadata.disabledInMonthlyCycle) === 'true');
  }, []);
  const data = React.useMemo(() => {
    if (!productId) {
      return [];
    }
    const uniqueIds = new Set();
    return (featuresGridData.namespaces ?? []).flatMap(namespace => (namespace.features ?? []).filter(disabledInMonthly)).filter(feature => {
      var _feature$values;
      return (_feature$values = feature.values) == null || (_feature$values = _feature$values[productId]) == null ? void 0 : _feature$values.available;
    }).filter(feature => {
      var _feature$content;
      const key = String((_feature$content = feature.content) == null || (_feature$content = _feature$content.name) == null ? void 0 : _feature$content.translationKey);
      if (uniqueIds.has(key)) {
        return false;
      }
      uniqueIds.add(key);
      return true;
    });
  }, [featuresGridData.namespaces, disabledInMonthly, productId]);
  return {
    data,
    ...asyncState
  };
};
//# sourceMappingURL=useMonthlyDisabledFeatures.js.map